<template>
<v-row justify="center">
    <v-dialog v-model="dialog" ref="modal" @keydown.esc="clearFields()" persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="loadProps()"> 
                <v-icon> mdi-pencil </v-icon>
            </v-btn>             
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Cadastro de Coleção </span>
            </v-card-title>
            <v-card-subtitle>
                Aqui você deverá cadastrar a sua Coleção (Ou Cardápio)
                <v-divider></v-divider>
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="10" sm="10">
                            <v-text-field v-model="nome" label="Nome da Coleção *" required></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">                  
                                    <v-switch v-on="on" flat v-model="status" :label="(status) ? 'Ativa' : 'Inativa'"></v-switch>
                                </template>
                                <span>Somente uma Coleção poderá estar ativa.</span>
                            </v-tooltip>   
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-text-field v-model="descricao" label="Descrição da Coleção *"></v-text-field>
                        </v-col>                        
                    </v-row>
                </v-container>
                <small>* Campos Obrigatórios</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="clearFields()">Fechar</v-btn>
                <v-btn color="blue darken-1" :loading="loading" text @click="saveCollection()">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-row>
</template>

<script>
import {
    db
} from '@/main'
import dbFunctions from "@/dbFunctions"
import store from "@/store"

export default {
    name: 'EditCollection',
    props: ['selCol','selColId'],
    data: () => ({
        dialog: false,
        loading: false,
        rules: {
            required: value => !!value || 'Campo Obrigatório.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => ('The email and password you entered don\'t match'),
        },
        nome: "",
        status:false,
        key: 0,
        descricao: ''

    }),
    methods: {
        loadProps(){
            this.nome = this.selCol.nome, 
            this.status = this.selCol.ativo, 
            this.descricao = this.selCol.descricao
        },
        saveCollection() {
            this.getDataInfo = dbFunctions.getDataInfo

            // console.log("add",this.$store.getters.company.data)
            this.loading = true
            const collection = {
                nome: this.nome,
                empresa: db.collection("empresas").doc(this.$store.getters.company.data.id),
                updateAt: new Date(),
                ativo: this.status,
                descricao: this.descricao
            }           
           db.collection('colecoes').doc(this.selColId).update(collection).then(async() => {
                this.loading = false
                let success = {
                    'active':true,
                    'color':'success',
                    'message':'Coleção Salva com Sucesso'
                }

                await this.reloadData(this.$store.getters.company.data.id)
                this.$emit("loadMessage",success)
                this.$emit("listEdit")
                this.clearFields()
            }).catch(function (error) {
                let errorMessage = {
                    'active':true,
                    'color':'error',
                    'message': error
                }          
                console.error('Error to Save Collection: ' + error)
                this.$emit("loadMessage",errorMessage)
            })
        },
        clearFields(){
            this.nome = null,
            this.status = null,
            this.dialog = false
            this.key += 1
        }, 
        async reloadData(companyId){
            let dataStore = await this.getDataInfo(companyId)
            store.dispatch("fetchData",dataStore)
            // console.log("reloadData", dataStore)
        },               
    },
}
</script>
